import ResponsiveGuide from 'components/misc/ResponsiveGuide'
import gradient from 'assets/gradient.jpg'

export default function TestLayout({children}) {
    return (
        <>
        <ResponsiveGuide/>
        <main className="w-screen h-screen bg-white bg-left-top bg-no-repeat bg-gradient">
            {children}
        </main>
        </>
    )
}
